import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { PageSkeleton } from './ui/page-skeleton';

interface AuthInitializerProps {
  children: React.ReactNode;
}

export function AuthInitializer({ children }: AuthInitializerProps) {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <PageSkeleton />;
  }

  return <>{children}</>;
}
